import { ArrowLeft } from "@phosphor-icons/react/dist/ssr";
import { useRouter } from "next/router";

export default function SubNavigationMobile({ label }) {
  const router = useRouter();
  return (
    <div className='sticky top-0 z-10 flex items-center justify-between w-full py-2 text-xs bg-background/90 backdrop-blur-md'>
      <button
        type='button'
        onClick={() => router.back()}
        className='inline-flex items-center justify-center flex-shrink-0 transition-colors rounded-full size-9 bg-white/10'
      >
        <ArrowLeft weight='bold' className='text-lg' />
      </button>
      <span className='text-white/40'>{label}</span>
    </div>
  );
}
